export const ENV = (process.env.ENVIRONMENT && process.env.ENVIRONMENT !== 'LOCAL') ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE || 'es-CO'


export const concourseId = {
  DEV: {
    'es-CO': 329,
    'es-EC': 438,
    'es-PE': 439,
  },
  PDN: {
    'es-CO': 393,
    'es-EC': 486,
    'es-PE': 487,
  },
}[ENV || 'development'][LOCALE || 'es-CO']

export const gameId = concourseId

export const activityName = 'school'

export const actualStage = {
  'es-CO': "Etapa 3: del 16 de julio al 31 de agosto",
  'es-PE': "",
  'es-EC': "Etapa 2: del 7 de noviembre al 15 diciembre",
}[LOCALE]

export const rangeAge = {
  'es-CO': {
    minAge: 9,
    maxAge: 19,
  },
  'es-PE': {
    minAge: 9,
    maxAge: 17,
  },
  'es-EC': {
    minAge: 9,
    maxAge: 17,
  },
}[LOCALE]

export const KEYS_PATTERN = /^[A-Za-z0-9\s]+$/g
export const NAME_PATTERN = /^([^\s][A-zÀ-ž\s]+)*$/
export const EMAIL_PATTERN = /^(([^<>()\]\\.,;:=\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const NUMBER_PATTERN = /^[0-9]*$/i
export const FORMAT_NUMBER_PATTERN = /(\d)(?=(\d{3})+(?!\d))/g
export const NAME_MIN_LENGTH = 3
export const PASSWORD_MIN_LENGTH = 6
export const PASSWORD_MAX_LENGTH = 40
 
export const isActivityClose = ({
  'es-CO': true,
  'es-PE': true,
  'es-EC': false
})[process.env.LOCALE] || false;